import React, { useEffect, useState } from "react";
import "./style.css";
import { Select, MenuItem } from "@mui/material";
import NextButton from "./components/NextButton";
import ProfileSelection from "./components/ProfileSelection";
import Dropdown from "./components/Dropdown";
import { useNavigate } from "react-router-dom";
import { PATH, USER_PROFILE_SECTION } from "./constants";
import { styled } from "@mui/material/styles";
import { roles } from "./roleLists";
import { countryList } from "./countryLists";
import ApiClient from "./apisClient";
import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
  buttonSection: {
    marginLeft: "250px",
  }
};

const api = new ApiClient();
const UserProfileSelection = ({isLoading}) => {
  const history_ = useNavigate();

  const [profile, setProfile] = useState("rental-textile-laundry");
  const [industry, setIndustry] = useState("");
  const [country, setCountry] = useState("");
  const [unit, setUnit] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);

  const handleProfileChange = (event) => setProfile(event.target.value);
  const handleIndustryChange = (event) => setIndustry(event.target.value);
  const handleUnitChange = (event) => setUnit(event.target.value);
  const handleRolesChange = (event) => setRole(event.target.value);

  // Get user from local storage
  const user = JSON.parse(localStorage.getItem('user'));

  // Handle country change from dropdown
  const handleCountryChange = (event) => {
    setCountry(event.target.value);
    console.log(event.target.value);
  };

  const units = ["Metric", "US"];
  const industries = ["Industry 1", "Industry 2"];

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user_api = await api.get('/api/v1/users');
        if (user_api) {
          setRole(user_api.role || user.Role);
          setCountry(user_api.city || user.City);
          setUnit(user_api.units || units[0]);
          setIndustry(user_api.industry || user.Business_Industry);
        } else {
          setRole(user.Role || roles[0]);
          setCountry(user.City || countryList[0]);
          setUnit(units[0]);
          setIndustry(user.Business_Industry || industries[0]);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        alert('Error fetching user data');
        setRole(roles[0]);
        setCountry(countryList[0]);
        setUnit(units[0]);
        setIndustry(industries[0]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Handle API call to update user profile
  const handleProfileUpdate = async () => {
    const payload = {
      city: country,
      role: role,
      units: unit,
      industry: industry || "",
      profile: profile
    };
    try {
     api.put('/api/v1/users/settings', payload);
      await delay(500); // Add a 500ms delay
      history_(PATH.rentalTextileLaundryPath);
    } catch (err) {
      console.log(err);
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  if (loading) {
    //add mui loading component
    return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress size={'10rem'} color='error'/>
  </Box>
    );
  }

  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <p className="user-selection-info-text">
        {USER_PROFILE_SECTION.INFO_TEXT}
        <ol>
          {USER_PROFILE_SECTION.LIST_ITEMS.map(item => <li key={item}>{item}</li>)}
        </ol>
        {USER_PROFILE_SECTION.INFO_TEXT_2}
      </p>
      <ProfileSelection
        profile={profile}
        handleProfileChange={handleProfileChange}
      />
      {profile === USER_PROFILE_SECTION.RENTAL_TEXTILE_LAUNDRY_PROFILE && renderDropdowns([
        { options: countryList, selected: country, setSelected: handleCountryChange, text: USER_PROFILE_SECTION.SELECT_COUNTRY_TEXT },
        { options: roles, selected: role, setSelected: handleRolesChange, text: USER_PROFILE_SECTION.SELECT_ROLE_TEXT },
        { options: units, selected: unit, setSelected: handleUnitChange, text: USER_PROFILE_SECTION.SELECT_UNIT_TEXT },
      ])}

      {profile === USER_PROFILE_SECTION.FR_CLOTHING_PROFILE && renderDropdowns([
        { options: industries, selected: industry, setSelected: setIndustry, text: USER_PROFILE_SECTION.SELECT_INDUSTRY_TEXT },
        { options: countryList, selected: country, setSelected: setCountry, text: USER_PROFILE_SECTION.SELECT_COUNTRY_TEXT },
        { options: roles, selected: role, setSelected: setRole, text: USER_PROFILE_SECTION.SELECT_ROLE_TEXT },
        { options: units, selected: unit, setSelected: setUnit, text: USER_PROFILE_SECTION.SELECT_UNIT_TEXT },
      ])}
      <section style={styles.buttonSection}>
        {profile === USER_PROFILE_SECTION.RENTAL_TEXTILE_LAUNDRY_PROFILE && <NextButton onClick={handleProfileUpdate} />}
        {profile === USER_PROFILE_SECTION.FR_CLOTHING_PROFILE && <NextButton onClick={handleProfileUpdate} />}
      </section>
    </div>
  );
};

const renderDropdowns = (dropdowns) => (
  <>
    {dropdowns.map(({ options, selected, setSelected, text }) => (
      <Dropdown
        key={text}
        options={options}
        selected={selected}
        setSelected={setSelected}
        text={text}
      />
    ))}
  </>
);

export default UserProfileSelection;